import { ITrade } from '@shared/models';

export interface State {
  loading: boolean;
  data: ITrade;
  error: string;
}

export const initialState: State = {
  loading: false,
  data: null,
  error: null
};
